<template>
	<div v-if="asset != null">
		<options :asset_id="asset.asset_id" :project_id="asset.project_id" :tab_index="tab_index" @selectedApartment="selectedApartmentData" />
	</div>
</template>
<script>
	import options from "./Options";
	export default {
		name: "apartments",
		components: {options},
		props: {
			asset: {default: null},
			tab_index: {default: null}
		},
		data() {
			return {
				selectedApartment: null,
				apartments: [],
        //domain: process.env.VUE_APP_CUSTOMER_DOMAIN
			}
		},
		mounted() {
			this.selectedApartmentData();
		},
		methods: {
			selectedApartmentData(value) {
				this.selectedApartment = value;
			}
		},
		watch: {
			selectedApartment(newValue) {
				if(newValue){
					this.$emit('selectedApartment', this.selectedApartment);
				}
				
			}
		},
	};
</script>
<style>
	.list-Apartment {
		height: 16em;
	}
</style>